module.exports = __webpack_public_path__ + "static/procesKreacjaMobile@x2-60210fb0cb8a168c1e6c039dfb774f8e.png";